import React from "react";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import MaterialTable from 'material-table';

var Utils = require ('Utils') ;

var sdf = require('date-format');
const CourseStudentList = ( { course, students, isFull  } ) =>  {
        var today = new Date();
        let studentsFixed = students.map( (st, idx) => {
            st.phone = ( (st.phone_mobile&& " / "+st.phone_mobile) + 
            (st.phone_extra? " / "+st.phone_extra:'') + 
            (st.phone_home? " / "+st.phone_home:'') + 
            (st.phone_emergency? " / "+st.phone_emergency:'') + 
            (st.phone_work? " / "+st.phone_work:'')).replace('null','').substring(3); 
            ;

            var birthDate = st.birthdate?new Date(st.birthdate.replace('Z','')):today;
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            st.order = idx + 1;
            st.full_name = Utils.capitalize(st.last_name + ', '+ st.name);

            st.nacim =  sdf.asString('dd/MM/yy', birthDate) ;
            st.edad = age;
            return st ;
        })
        
        let cols = [] ;

        if (isFull) {
            cols = [ 
                { width: '1%', title: '#', field: 'order'  } ,
                { title: 'Alumno', field: 'full_name' },
                { title: 'DNI', field: 'doc_nbr' } ,
                { title: 'F.Nacim', field: 'nacim' }, 
                
                { title: 'Localidad', field: 'addr_city' }, 
                { title: 'Calle', field: 'addr_street' }, 
                { title: 'Nro', field: 'addr_street_nbr' }, 
                { title: 'CP', field: 'addr_zip_code' }, 
                { title: 'Telefono', field: 'phone' } 
                    ];
           
        } else {
            cols = [ 
                { width: '1%', title: '#', field: 'order'  } ,
                { title: 'Alumno', field: 'full_name' }
                    ];
            }
            return (
                <>
                    <MaterialTable
                        title={'LISTADO DE ALUMNOS DE '.concat(course, ' - Total ',students.length,' alumnos')}
                        columns={cols}
                        data={ studentsFixed }        
                        options={{
                            exportButton: {
                                csv: true,
                                pdf: true
                            } ,
                            search: false,
                            paging: false,


                            exportPdf: (columns, data) => {
                                const doc = new jsPDF();
                              
                                const columnTitles = columns
                                    .map(columnDef => columnDef.title);
                                
                                const pdfData = data.map(rowData =>
                                      columns.map(columnDef => rowData[columnDef.field]),
                                    );
                                doc.text('LISTADO DE '.concat(course, ' - Total ',students.length,' alumnos'),10,10);

                                doc.autoTable({
                                   head: [columnTitles],
                                   body: pdfData
                                    
                                });
                              
                                doc.save(course + `.pdf`);
                              }

                        }}
                        localization={{
                            toolbar: {
                              exportPDFName: "Exportar PDF",
                              exportCSVName: "Exportar Excel"
                            }
                          }}
                    />
                </>
            );
        }   
  
export { CourseStudentList } ;
